<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()">
      <span style="cursor: pointer;">&times;</span>
    </div>
    
    <h5>{{ uploadTitle }}</h5>
    
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="uploadQuestion()">
      <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
        <p>{{ modelError }}</p>
      </div>
      
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Select File</label>
        <input type="file" class="form-control file-select" (change)="onQuestionFileChange($event)">
      </div>
      
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Question Category</label>
        <ng-select class="form-select" [(ngModel)]="upQues.category" [ngModelOptions]="{ standalone: true }">
          <ng-option selected value="" disabled>Select Category</ng-option>
          <ng-option *ngFor="let cat of categoryList" [value]="cat.category">
            {{ cat.category }}
          </ng-option>
        </ng-select>
      </div>
      
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Question Format</label>
        <ng-select class="form-select" [(ngModel)]="upQues.questionFormat" [ngModelOptions]="{ standalone: true }">
          <ng-option selected value="" disabled>Select Format</ng-option>
          <ng-option value="Format1">Format1</ng-option>
          <ng-option value="Format2">Format2</ng-option>
          <ng-option value="None">Excel</ng-option>
        </ng-select>
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Encoding</label>
        <ng-select class="form-select" [(ngModel)]="upQues.encoding" [ngModelOptions]="{ standalone: true }">
          <ng-option selected value="" disabled>Select Encoding</ng-option>
          <ng-option value="Default">Default</ng-option>
          <ng-option value="UTF8">UTF-8</ng-option>
        </ng-select>
      </div>

      <div class="row mb-3 mr-0 col-md-10">
        <div class="col-md-6">
          <div class="form-check">
            <input 
              class="form-check-input" 
              type="checkbox" 
              [(ngModel)]="upQues.isNegativeMark" 
              [ngModelOptions]="{ standalone: true }">
            <label class="form-check-label">
              NegativeMark
            </label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-check">
            <input 
              class="form-check-input" 
              type="checkbox" 
              [(ngModel)]="upQues.isHtml" 
              [ngModelOptions]="{ standalone: true }">
            <label class="form-check-label">
              Use Raw HTML
            </label>
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit">
        Upload
      </button>
    </form>

    <div class="d-flex align-content-between justify-content-between mt-2">
      <a href="/assets/templates/Question_Upload_Format_1.txt" download>
        Download Template Format 1
      </a>
      <a href="/assets/templates/Question_Upload_Format_2.txt" download>
        Download Template Format 2
      </a>
      <a href="/assets/templates/Question Format.xlsx" download>
        Download Template Excel
      </a>
    </div>
  </div>
</div>